import { type IDropdownItem } from 'shared/ui'
import { type SmartView } from 'entities/SmartViews/model/SmartView'
import { type ConversationMenuStore } from 'pages/conversations/ui/ConversationMenu'

const typeDeleteSmartView = 'delete_smart_view'

type IActionDeleteSmartView = {
  inbox: SmartView
  item: IDropdownItem
}

export const menuDeleteSmartView = (): IDropdownItem => {
  return {
    id: typeDeleteSmartView,
    iconL: 'delete',
    label: 'Delete',
  }
}

export const actionDeleteSmartView = async (
  { inbox, item }: IActionDeleteSmartView,
  store: ConversationMenuStore
) => {
  if (item.id === typeDeleteSmartView) {
    store.smartViewsMenuStore.onOpenModalDelete(inbox)
  }
}
